import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { setAppEmailModalOpen } from "../../../redux/slices/appSettingsSlice";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectHTTP, selectIsCms } from "../../../redux/slices/configSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import { selectReceiptId } from "../../../redux/slices/receiptSlice";
import ReceiptSocialSharing from "./ReceiptSocialSharing";

const ConnectedReceiptSocialSharing = ({ controlId }) => {
    const name = useSelector((state) =>
        selectSpecificFormSetting(state, "name"),
    );
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { alias } = p2pSettings;
    const receiptId = useSelector(selectReceiptId);

    const HTTP_HOST = useSelector(selectHTTP);
    const {
        ENUMS: { DefaultView },
    } = constants;

    const isCms = useSelector(selectIsCms);

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: {
            defaultTweetContent = "I'm fundraising for %EventName%! Want to sign-up?",
            enableEmailSharing = 1,
            enableFacebookSharing = 1,
            enableTwitterSharing = 1,
            socialShareLabel = "Share via",
        },
    } = control;

    const sharerUrl = encodeURIComponent(`${HTTP_HOST}/event/${alias}/`);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${sharerUrl}`;
    const twitterShareUrl = `https://twitter.com/intent/tweet?url=${sharerUrl}&text=${encodeURIComponent(
        defaultTweetContent.replace("%EventName%", name),
    )}`;

    const receiptSocialSharingProps = {
        enableEmailSharing: Number(enableEmailSharing),
        enableFacebookSharing: Number(enableFacebookSharing),
        enableTwitterSharing: Number(enableTwitterSharing),
        socialShareLabel,
        facebookShareUrl,
        isCms,
        twitterShareUrl,
        controlId,
        receiptId,
        setAppEmailModalOpen,
    };

    return <ReceiptSocialSharing {...receiptSocialSharingProps} />;
};

ConnectedReceiptSocialSharing.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptSocialSharing;
